<div class="repair-alert-container">
  <div class="panel">
    <div class="header border-bottom" #headerContainer>
      <div class="header-container" (click)="toggleAccordionPanel()">
        <div class="header-text">
          <span>
            @if (!openAccordion) {
              <mc-icon slot="trigger" icon="chevron-right" size="20" fit="medium"></mc-icon>
            }
            @if (openAccordion) {
              <mc-icon slot="trigger" icon="chevron-down" size="20" fit="medium"></mc-icon>
            }
          </span>
          <div #header>Repair Alerts</div>
        </div>
        <div>
          <ng-content select="left-corner-menu"></ng-content>
        </div>
      </div>
      <div class="sub-header-container">
        <ng-content select="sub-header"></ng-content>
      </div>
    </div>
    @if (openAccordion) {
      <div class="content">
        <form [formGroup]="raAlertFormGroup">
          <div class="pure-g">
            <div class="pure-u-md-8-24 p-b-16 p-r-16">
              <mc-input
                label="Container Number"
                placeholder="Enter Container Number"
                fit="small"
                ngDefaultControl
                formControlName="containerNum">
              </mc-input>
              @if (raAlertFormGroup.controls.containerNum.hasError('pattern')) {
                <span slot="errormessage" class="mds-error__text-color m-t-8">Invalid input</span>
              }
            </div>
            <div class="pure-u-md-8-24 p-b-16 p-r-16">
              <mc-input
                label="Work Order Number"
                placeholder="Enter Work Order Number"
                fit="small"
                ngDefaultControl
                formControlName="woNum">
              </mc-input>
              @if (raAlertFormGroup.controls.woNum.hasError('pattern')) {
                <span slot="errormessage" class="mds-error__text-color m-t-8">Invalid input</span>
              }
            </div>
            <div class="pure-u-md-8-24 p-b-16 p-r-16">
              <mc-multi-select
                ngDefaultControl
                formControlName="shopCode"
                aria-placeholder="Select shop codes"
                label="Shop Code"
                fit="small">
                @for (shop of shops; track $index) {
                  <mc-option [value]="shop.maintenanceShopCode">{{ shop.maintenanceShopCode }}</mc-option>
                }
              </mc-multi-select>
            </div>
            <div class="pure-u-md-24-24">
              <div class="pure-u-md-8-24 p-b-16 p-r-8">
                <mc-input-date
                  [attr.invalid]="isControlInErrorState(raAlertFormGroup.controls.fromDate)"
                  ngDefaultControl
                  formControlName="fromDate"
                  fit="small"
                  format="DD-MM-YYYY"
                  placeholder="DD-MM-YYYY"
                  yearcap="0"
                  [max]="today"
                  slot="from"
                  label="From">
                  @if (raAlertFormGroup.controls.fromDate.hasError('required')) {
                    <span slot="errormessage">Required</span>
                  }
                </mc-input-date>
              </div>
              <div class="pure-u-md-8-24 p-b-16 p-r-8">
                <mc-input-date
                  [attr.invalid]="isControlInErrorState(raAlertFormGroup.controls.toDate)"
                  ngDefaultControl
                  formControlName="toDate"
                  fit="small"
                  format="DD-MM-YYYY"
                  placeholder="DD-MM-YYYY"
                  yearcap="0"
                  [max]="today"
                  slot="to"
                  label="To">
                  @if (raAlertFormGroup.controls.toDate.hasError('required')) {
                    <span slot="errormessage">Required</span>
                  }
                </mc-input-date>
              </div>
              @if (raAlertFormGroup.hasError('fromLessThanToValidator')) {
                <div class="mds-error__text-color m-t-8">From date must be less than or same as to date</div>
              }
              @if (raAlertFormGroup.hasError('dateRangeExceedsOneMonth')) {
                <div class="mds-error__text-color m-t-8">
                  <span class="error-message">Max period allowed is 30 days.</span>
                </div>
              }
            </div>
          </div>
          <div class="pure-g">
            <div class="pure-u-md-6-24 pure-u-lg-4-24 p-t-16 p-r-8" style="height: 54px; align-items: end">
              <mc-button
                fit="small"
                [disabled]="!isAnyFilterFilled || raAlertFormGroup.invalid || initiateRaAlertRequestApiCallStatus === 'IN_PROGRESS'"
                [loading]="initiateRaAlertRequestApiCallStatus === 'IN_PROGRESS'"
                (click)="onApplyFilter()">
                Apply Filter
              </mc-button>
            </div>
          </div>
        </form>
      </div>
    }
  </div>
  @if (data.length > 0) {
    <div class="pure-g m-t-8 quick-filter-box" style="display: flex; justify-content: flex-end">
      <div>
        <mc-button
          class="utility-button download"
          label="Button "
          variant="filled"
          appearance="neutral"
          fit="medium"
          icon="tray-arrow-down"
          hiddenlabel
          padding="default"
          (click)="onDownload()"
          [disabled]="raAlertFormGroup.invalid || !raAlertFormGroup.controls.fromDate.value || !raAlertFormGroup.controls.toDate.value">
        </mc-button>
      </div>
    </div>
  }

  <div class="m-t-12 table-container">
    @if (data.length > 0) {
      <mc-table
        fit="small"
        data-cy="work-order-list"
        [data]="data"
        fit="small"
        [columns]="columns"
        nowrap="true"
        sortdefaultdirection="ascending"
        height="100%">
      </mc-table>
    } @else {
      @if (displayGridDataMsg) {
        <div class="pure-g">
          <div class="pure-u-md-24-24 pure-u-lg-24-24 pure-u-xl-24-24 flex-container flex-center no-file-selected">
            <span i18n>Please select the filters to load the data</span>
          </div>
        </div>
      } @else {
        <div class="pure-g">
          <div class="pure-u-md-24-24 pure-u-lg-24-24 pure-u-xl-24-24 m-t-108 flex-container flex-center no-data">
            <span i18n>No Data Found</span>
          </div>
          <div class="pure-u-md-24-24 pure-u-lg-24-24 pure-u-xl-24-24 m-t-36 flex-container flex-center">
            <span i18n>To widen your search, change filters.</span>
          </div>
        </div>
      }
    }
  </div>
</div>
@if (data.length > 0) {
  <div class="pure-g m-t-16 footer">
    <div class="pure-u-md-6-24 pure-u-lg-4-24 pure-u-xl-4-24">
      <mc-select
        style="width: 140px; display: block"
        [value]="pageLimit"
        optionswidth="100px"
        ngDefaultControl
        label="Per page"
        labelposition="left"
        fit="small"
        (optionselected)="onPageLimitChange($event)">
        @for (pageCount of [10, 20, 50, 100, 200]; track $index) {
          <mc-option [value]="pageCount">{{ pageCount }}</mc-option>
        }
      </mc-select>
    </div>

    <div class="pure-u-md-12-24 pure-u-lg-16-24 pure-u-xl-16-24 flex-container flex-center">
      @if (data.length != totalItemCount) {
        <mc-pagination
          hiddenlabels
          [currentpage]="currentPage"
          [totalpages]="lastPage"
          visiblepages="7"
          (pagechange)="onPageChange($event)"
          fit="small">
        </mc-pagination>
      }
    </div>

    <div class="pure-u-md-6-24 pure-u-lg-4-24 pure-u-xl-4-24 text-align-right">
      <span class="page-description" i18n>Showing {{ data.length }} of {{ totalItemCount }}</span>
    </div>
  </div>
}
